import { Button, Col, Row } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  addUsersToAddress,
  deleteCompanyAddress,
  getAddressById,
  getAllCompaniesByOfficeId,
  modifyCompanyAddress,
  saveCompanyAddress,
} from "../../actions/company";
import { withTranslation } from "react-i18next";
import { PlusOutlined } from "@ant-design/icons";
import { getAllUsers, getAllUsersByOffice } from "../../actions/users";
import { getAllOfficeAddresses, getOneOfficeById } from "../../actions/office";
import AddressesList from "../../components/Addresses/AddressesList/addressesList";
import CreateOrUpdateAddressModal from "../../components/Addresses/CreateOrUpdateAddressModal/createOrUpdateAddressModal";
import { isArray } from "lodash";
import UpdateSetOfUsersModal from "../../components/Users/UpdateSetOfUsersModal/updateSetOfUsersModal";
import { userRoles } from "../../constants/roles-types";

const mapDispatchToProps = (dispatch) => {
  return {
    getAllOfficeAddresses: (officeId) =>
      dispatch(getAllOfficeAddresses(officeId)),
    saveCompanyAddress: (params) => dispatch(saveCompanyAddress(params)),
    modifyCompanyAddress: (params) => dispatch(modifyCompanyAddress(params)),
    deleteCompanyAddress: (id) => dispatch(deleteCompanyAddress(id)),
    getAddressById: (addressId) => dispatch(getAddressById(addressId)),
    getAllUsers: (groupIds, companyId) =>
      dispatch(getAllUsers(groupIds, companyId)),
    getAllUsersByOffice: (officeId) => dispatch(getAllUsersByOffice(officeId)),
    addUsersToAddress: (params) => dispatch(addUsersToAddress(params)),
    getAllCompaniesByOfficeId: (officeId) =>
      dispatch(getAllCompaniesByOfficeId(officeId)),
    getOneOfficeById: (officeId) => dispatch(getOneOfficeById(officeId)),
  };
};

class ConnectedOfficeAddressesPage extends Component {
  formRef = React.createRef();

  state = {
    targetKeys: [],
    selectedKeys: [],
    companyName: "",
    baseTime: null,
    addressBaseTime: null,
    anonymizationTime: 30,
    officeAnonymizationTimeLimit: 30,
    companies: [],
    companyId: null,
    addCompany: false,

    createOrUpdateModalVisible: false,
    createOrUpdateModalMode: "create",
    selectedAddress: null,
    office: null,
    updateSetOfUsersModalVisible: false,
    addeddUsers: [],
    allUsers: [],
  };

  componentDidMount = async () => {
    let officeId = this.props.user.officeId;
    await this.props.getAllCompaniesByOfficeId(officeId);
    this.fetchOfficeAddresses();
    await this.props.getOneOfficeById(this.props.user.officeId);
    if (this.props.officeStatus) {
      this.setState({
        office: isArray(this.props.office)
          ? this.props.office[0]
          : this.props.office,
      });
    }
  };

  fetchOfficeAddresses = async () => {
    this.setState({ loadingAddresses: true });
    await this.props.getAllOfficeAddresses(this.props.user.officeId);
    this.setState({ loadingAddresses: false });
  };

  handleOpenNewAddressModal = () => {
    this.setState({
      createOrUpdateModalVisible: true,
      createOrUpdateModalMode: "create",
    });
  };

  handleOpenModifyAddressModal = (record) => {
    this.setState({
      createOrUpdateModalVisible: true,
      createOrUpdateModalMode: "modify",
      selectedAddress: record,
    });
  };

  handleCloseCreateOrUpdateAddressModal = () => {
    this.setState({
      createOrUpdateModalVisible: false,
      createOrUpdateModalMode: "create",
      selectedAddress: null,
    });
  };

  handleCloseUpdateSetOfUsersModal = () => {
    this.setState({
      updateSetOfUsersModalVisible: false,
      allUsers: [],
      addeddUserIds: [],
    });
  };

  handleOpenUpdateSetOfUsersModal = async (address) => {
    if (address.companyId) {
      await this.props.getAllUsers([userRoles.USER], address.companyId);
    } else {
      await this.props.getAllUsersByOffice(address.officeId);
    }
    await this.props.getAddressById(address.id);
    if (this.props.status) {
      const target = this.props.address.users.map((user) => user.id);
      this.setState({
        updateSetOfUsersModalVisible: true,
        addeddUserIds: target,
        allUsers: this.props.users,
        addressId: address.id,
      });
    }
  };

  handleDeleteAddress = async (addressId) => {
    await this.props.deleteCompanyAddress(addressId);
    if (this.props.saveStatus) {
      this.fetchOfficeAddresses();
    }
  };

  handleSaveSelectedUsers = async (params) => {
    await this.props.addUsersToAddress(params);
    this.handleCloseUpdateSetOfUsersModal();
    await this.fetchOfficeAddresses()
  };

  handleDelete = async (id) => {
    await this.props.deleteCompanyAddress(id);
    if (this.props.saveStatus) {
      await this.props.getAllOfficeAddresses(
        this.props.user.officeId
          ? this.props.user.officeId
          : this.props.officeId
      );
    }
  };

  createNewAddress = async (addressData) => {
    await this.props.saveCompanyAddress(addressData);
    await this.fetchOfficeAddresses();
  };

  updateAddress = async (addressData) => {
    await this.props.modifyCompanyAddress(addressData);
    await this.fetchOfficeAddresses();
  };

  render() {
    return (
      <div style={{ overflowY: "auto" }}>
        <Row>
          <Col span={24} style={{ padding: "1em" }}>
            <Button type="primary" onClick={this.handleOpenNewAddressModal}>
              <PlusOutlined />
              {this.props.t("addresses-create-new-address-button-label")}
            </Button>
          </Col>
        </Row>

        <Row>
          <Col span={24} style={{ padding: "1em" }}>
            <AddressesList
              loading={this.state.loadingAddresses}
              addresses={this.props.addresses}
              handleOpenUpdateUsersToAddressModal={
                this.handleOpenUpdateUsersToAddressModal
              }
              handleOpenModifyAddressModal={this.handleOpenModifyAddressModal}
              handleDeleteAddress={this.handleDeleteAddress}
              handleOpenUpdateSetOfUsersModal={
                this.handleOpenUpdateSetOfUsersModal
              }
            />
          </Col>
        </Row>
        <CreateOrUpdateAddressModal
          modalVisible={this.state.createOrUpdateModalVisible}
          modalMode={this.state.createOrUpdateModalMode}
          companies={this.props.companies}
          handleCloseCreateOrUpdateAddressModal={
            this.handleCloseCreateOrUpdateAddressModal
          }
          selectedAddress={this.state.selectedAddress}
          office={this.state.office}
          createNewAddress={this.createNewAddress}
          updateAddress={this.updateAddress}
          saveStatus={this.props.saveStatus}
        />
        <UpdateSetOfUsersModal
          modalVisible={this.state.updateSetOfUsersModalVisible}
          handleCloseUpdateSetOfUsersModal={
            this.handleCloseUpdateSetOfUsersModal
          }
          addeddUserIds={this.state.addeddUserIds}
          allUsers={this.state.allUsers}
          addressId={this.state.addressId}
          handleSaveSelectedUsers={this.handleSaveSelectedUsers}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  user: state.loginReducer.user,
  company: state.companyReducer.company,
  status: state.companyReducer.status,
  addresses: state.companyReducer.addresses,
  address: state.companyReducer.address,
  saveStatus: state.companyReducer.saveStatus,
  users: state.usersReducer.users,
  officeStatus: state.officeReducer.status,
  office: state.officeReducer.office,
  companies: state.companyReducer.companies,
});
const OfficeAddressesPage = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ConnectedOfficeAddressesPage)
);
export default OfficeAddressesPage;
